<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,7.97C16,7.96,16,7.96,16,7.95C16,7.95,16,7.94,16,7.94C16,7.93,16,7.93,16,7.92C16,7.91,16,7.91,16,7.9C16,7.9,16,7.9,16,7.9C15.98,7.76,15.92,7.64,15.83,7.54C15.34,6.91,14.76,6.34,14.18,5.82C14.18,5.82,11.02,8.08,11.02,8.08C10.98,9.690000000000001,9.66,10.98,8.04,10.98C7.73,10.98,7.44,10.92,7.16,10.83C7.16,10.83,5.09,12.3,5.09,12.3C5.53,12.49,5.99,12.66,6.46,12.77C7.43,13,8.4,13.01,9.38,12.82C10.26,12.65,11.12,12.28,11.91,11.84C13.16,11.14,14.3,10.17,15.29,9.09C15.47,8.89,15.66,8.68,15.82,8.469999999999999C15.91,8.370000000000001,15.97,8.25,15.99,8.11C15.99,8.11,15.99,8.11,15.99,8.11C15.99,8.1,15.99,8.1,15.99,8.09C15.99,8.08,15.99,8.08,15.99,8.07C15.99,8.07,15.99,8.059999999999999,15.99,8.059999999999999C15.99,8.05,15.99,8.05,15.99,8.04C15.99,8.030000000000001,15.99,8.02,15.99,8.01C16,7.99,16,7.98,16,7.97C16,7.97,16,7.97,16,7.97ZM15.57,3.8C15.82,3.62,16,3.34,16,3C16,2.45,15.55,2,15,2C14.78,2,14.59,2.08,14.43,2.2C14.43,2.2,14.42,2.19,14.42,2.19C14.42,2.19,11.75,4.1,11.75,4.1C11.06,3.7199999999999998,10.34,3.41,9.58,3.23C8.62,3,7.64,2.99,6.67,3.1799999999999997C5.79,3.3600000000000003,4.93,3.7199999999999998,4.14,4.17C2.89,4.87,1.75,5.84,0.76,6.92C0.58,7.12,0.39,7.33,0.23,7.54C0,7.83,0,8.17,0.22,8.46C0.73,9.120000000000001,1.33,9.71,1.95,10.25C2.13,10.41,2.33,10.54,2.51,10.69C2.51,10.69,0.42,12.19,0.42,12.19C0.42,12.19,0.43,12.2,0.43,12.2C0.18,12.38,0,12.66,0,13C0,13.55,0.45,14,1,14C1.22,14,1.41,13.92,1.57,13.8C1.57,13.8,1.58,13.81,1.58,13.81C1.58,13.81,15.58,3.81,15.58,3.81C15.58,3.81,15.57,3.8,15.57,3.8C15.57,3.8,15.57,3.8,15.57,3.8ZM5.16,8.8C5.09,8.54,5.05,8.280000000000001,5.05,8C5.05,6.36,6.39,5.02,8.04,5.02C8.66,5.02,9.23,5.23,9.7,5.55C9.7,5.55,5.16,8.8,5.16,8.8C5.16,8.8,5.16,8.8,5.16,8.8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'EyeOff',
} as DefineComponent
</script>
